import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import makeEffects from './effects'
import rootReducer from './reducers'
import runSubscribtions from './subscriptions'

const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [sagaMiddleware]
  const composeEnhancers = (
    process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose
  const enhancer = composeEnhancers(applyMiddleware(...middlewares))
  const store = createStore(rootReducer, enhancer)
  const effects = makeEffects()

  effects.forEach(sagaMiddleware.run)
  runSubscribtions(store)

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(rootReducer)
    })
  }

  return store
}

export default configureStore
